import { Toggle } from "@amzn/awsui-components-console";
import React from "react";

import { IconikAsset } from "./types";

export interface CartActionButtonProps {
  /** The asset this toggle adds to or removes from the cart. */
  item: IconikAsset;
  /** Whether the asset is already in the cart (drives the toggle's checked state). */
  inCart: boolean;
  /** Called with the asset when the user switches the toggle on. */
  onAdd: (item: IconikAsset) => void;
  /** Called with the asset when the user switches the toggle off. */
  onRemove: (item: IconikAsset) => void;
}

/**
 * Per-row "Add to Cart" control, rendered as a toggle: on = the asset is in
 * the cart, off = it is not. Switching it on adds the asset; switching it off
 * removes it, so a user can add and undo directly from the row.
 *
 * The toggle sits inside a clickable table row (a row click opens the Clip
 * Preview), so the wrapping span stops the click from bubbling — flipping the
 * toggle must not also open the preview.
 */
const CartActionButton: React.FC<CartActionButtonProps> = ({
  item,
  inCart,
  onAdd,
  onRemove,
}) => (
  <span
    onClick={(e) => e.stopPropagation()}
    style={{ display: "inline-flex" }}
  >
    <Toggle
      checked={inCart}
      onChange={({ detail }) =>
        detail.checked ? onAdd(item) : onRemove(item)
      }
      ariaLabel={`Add ${item.filename} to cart`}
    />
  </span>
);

export default CartActionButton;
